import styled from '@emotion/styled';
import LazyLoadTable from '__components/Kizen/LazyLoad/LazyLoadTable';
import BigTableLayout from '__components/Layout/BigTableLayout';
import Input from '__components/Kizen/Input';
import BasicModalWithConfirmation from '__components/Modals/presets/BasicModalWithConfirmation';

export const StyledLazyLoadTable = styled(LazyLoadTable)`
  position: relative;
  width: auto;
  thead {
    z-index: 0;
  }
`;

export const StyledBigTableLayout = styled(BigTableLayout)`
  min-height: auto;

  table {
    background-color: var(--color-background-white);
  }

  && > div {
    padding: 0;
  }

  && > div:last-child > div:last-child {
    margin-bottom: 25px;
  }
`;

export const Toolbar = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 36px;
  margin: 20px 0;

  > h2 {
    text-align: center;
  }
`;

export const TBSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: var(--color-background-white);
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;

export const PaginationWrapper = styled.div`
  padding: 20px 0 2px 0;
`;

export const StyledBasicModalWithConfirmation = styled(
  BasicModalWithConfirmation
)`
  .modal-content {
    .modal-body {
      > div {
        padding: 0;

        > div > div {
          margin-top: 0;
        }
      }

      padding-top: 0;
    }

    padding-top: 0;
  }
`;

export const DateTimeInputWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
